export enum surfaceDevPhaseSteps {
  CONSTRUCT_SUBMIT_WATER_REQUEST = 82,
  CONSTRUCT_CONSTRUCTION_KICKOFF = 83,
  CONSTRUCT_GRADE_ROCK_ROAD = 84,
  CONSTRUCT_GRADE_PITS = 85,
  CONSTRUCT_GRADE_ROCK_PAD = 86,
  CONSTRUCT_GRADE_ROCK_RIG_FOUNDATION = 87,
  CONSTRUCT_INSTALL_PIT_LINER = 88,
  CONSTRUCT_INSTALL_CELLAR_BOX = 89,
  CONSTRUCT_DRILLING_OPERATIONS = 90
}